export default function FeatureSection() {
  const features = [
    {
      icon: 'ri-database-2-line',
      title: '海量资源',
      desc: '收录数万部电影资源，涵盖各种类型，每日持续更新，满足你的观影需求。',
    },
    {
      icon: 'ri-4k-line',
      title: '高清画质',
      desc: '支持4K超清画质播放，每一帧都清晰细腻，带来极致的视觉享受。',
    },
    {
      icon: 'ri-speed-up-line',
      title: '流畅播放',
      desc: '全球CDN加速节点覆盖，不缓冲不卡顿，即点即播无需等待。',
    },
    {
      icon: 'ri-vip-crown-line',
      title: '免费观看',
      desc: '无需VIP会员，完全免费观影。好电影应该让每个人都能看到。',
    },
  ];

  return (
    <section className="py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-100 font-heading mb-3">
              平台特色
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              为什么选择6080影视？因为我们始终把用户体验放在第一位
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {features.map((feature, index) => (
              <div
                key={index}
                className="bg-background-100 border border-background-300/40 rounded-xl p-6 text-center hover:border-primary-500/30 transition-all duration-300 group"
              >
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-5 rounded-2xl bg-primary-500/10 text-primary-400 group-hover:bg-primary-500/20 transition-colors">
                  <i className={`${feature.icon} text-2xl`}></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-100 mb-2 font-heading">
                  {feature.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {feature.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}